<template>
  <div class="video-loading loading-dots">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      style="margin: auto; display: block; shape-rendering: auto"
      width="100px"
      height="100px"
      viewBox="0 0 100 100"
      preserveAspectRatio="xMidYMid"
    >
      <circle cx="84" cy="50" r="10" fill="#00a39b">
        <animate
          attributeName="r"
          repeatCount="indefinite"
          dur="0.5952380952380952s"
          calcMode="spline"
          keyTimes="0;1"
          values="10;0"
          keySplines="0 0.5 0.5 1"
          begin="0s"
        ></animate>
        <animate
          attributeName="fill"
          repeatCount="indefinite"
          dur="2.380952380952381s"
          calcMode="discrete"
          keyTimes="0;0.25;0.5;0.75;1"
          values="#00a39b;#f15822;#00a39b;#f15822;#00a39b;"
          begin="0s"
        ></animate>
      </circle>
      <circle cx="16" cy="50" r="10" fill="#00a39b">
        <animate
          attributeName="r"
          repeatCount="indefinite"
          dur="2.380952380952381s"
          calcMode="spline"
          keyTimes="0;0.25;0.5;0.75;1"
          values="0;0;10;10;10"
          keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1"
          begin="0s"
        ></animate>
        <animate
          attributeName="cx"
          repeatCount="indefinite"
          dur="2.380952380952381s"
          calcMode="spline"
          keyTimes="0;0.25;0.5;0.75;1"
          values="16;16;16;50;84"
          keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1"
          begin="0s"
        ></animate>
      </circle>
      <circle cx="50" cy="50" r="10" fill="#f15822">
        <animate
          attributeName="r"
          repeatCount="indefinite"
          dur="2.380952380952381s"
          calcMode="spline"
          keyTimes="0;0.25;0.5;0.75;1"
          values="0;0;10;10;10"
          keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1"
          begin="-0.5952380952380952s"
        ></animate>
        <animate
          attributeName="cx"
          repeatCount="indefinite"
          dur="2.380952380952381s"
          calcMode="spline"
          keyTimes="0;0.25;0.5;0.75;1"
          values="16;16;16;50;84"
          keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1"
          begin="-0.5952380952380952s"
        ></animate>
      </circle>
      <circle cx="84" cy="50" r="10" fill="#00a39b">
        <animate
          attributeName="r"
          repeatCount="indefinite"
          dur="2.380952380952381s"
          calcMode="spline"
          keyTimes="0;0.25;0.5;0.75;1"
          values="0;0;10;10;10"
          keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1"
          begin="-1.1904761904761905s"
        ></animate>
        <animate
          attributeName="cx"
          repeatCount="indefinite"
          dur="2.380952380952381s"
          calcMode="spline"
          keyTimes="0;0.25;0.5;0.75;1"
          values="16;16;16;50;84"
          keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1"
          begin="-1.1904761904761905s"
        ></animate>
      </circle>
      <circle cx="16" cy="50" r="10" fill="#f15822">
        <animate
          attributeName="r"
          repeatCount="indefinite"
          dur="2.380952380952381s"
          calcMode="spline"
          keyTimes="0;0.25;0.5;0.75;1"
          values="0;0;10;10;10"
          keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1"
          begin="-1.7857142857142856s"
        ></animate>
        <animate
          attributeName="cx"
          repeatCount="indefinite"
          dur="2.380952380952381s"
          calcMode="spline"
          keyTimes="0;0.25;0.5;0.75;1"
          values="16;16;16;50;84"
          keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1"
          begin="-1.7857142857142856s"
        ></animate>
      </circle>
    </svg>
  </div>
</template>
